export const translations = {
  en: {
    nav: {
      about: 'About',
      divisions: 'Divisions',
      experience: 'Experience',
      industries: 'Industries',
      workforce: 'Workforce',
      gallery: 'Gallery',
      contact: 'Contact',
      cta: 'Partner With Us',
    },
    hero: {
      eyebrow: 'EST. — INDUSTRIAL OPERATIONS / MEXICO',
      title_pre: 'Engineering, Infrastructure',
      title_accent: '& Global Workforce',
      title_post: 'Partnerships.',
      sub: 'Delivering industrial excellence, infrastructure development and workforce partnerships across Mexico and North America. Operational experience across 450+ project executions.',
      btn_primary: 'Explore Our Services',
      btn_secondary: 'Partner With Alpha 7',
      scroll: 'SCROLL',
      ticker: '450+ COMPLETED OPERATIONAL & INFRASTRUCTURE PROJECTS',
    },
    marquee: [
      'Industrial Construction',
      'Electrical Engineering',
      'Substations',
      'Fire Protection',
      'Agricultural Infrastructure',
      'Hydraulic Systems',
      'Workforce Partnerships',
      'Industrial Maintenance',
    ],
    about: {
      index: '01 — Identity',
      title_pre: 'A multidisciplinary',
      title_accent: 'industrial group',
      title_post: 'built on operational experience.',
      body_1: 'ALPHA 7 Soluciones y Proyectos is a multidisciplinary engineering, industrial operations and workforce partnership group based in Mexico, with operational experience across civil, electromechanical and industrial engineering, infrastructure development and workforce-intensive sectors.',
      body_2: 'Our work spans industrial construction, electrical systems, substations, hydraulic infrastructure, fire protection systems, agricultural infrastructure, greenhouses and large-scale industrial maintenance — supported by a corporate culture of reliability, transparency and operational excellence. More than 450 projects executed across industrial sectors.',
      pillars: ['Reliability', 'Operational Excellence', 'Transparency', 'Long-term Partnerships'],
    },
    divisions: {
      index: '02 — Divisions',
      title: 'Six divisions. One operational standard.',
      sub: 'A vertically integrated structure designed to support industrial clients and contractors across Mexico and North America.',
      items: [
        { id: 'construction', title: 'Construction', desc: 'Industrial construction, concrete structures and facility execution for warehouses, plants and infrastructure environments.' },
        { id: 'electrical', title: 'Electrical Engineering', desc: 'Industrial electrical systems, distribution, substations support and electromechanical execution.' },
        { id: 'operations', title: 'Industrial Operations', desc: 'On-site operational coordination for industrial environments, contractors and infrastructure programs.' },
        { id: 'infrastructure', title: 'Infrastructure Solutions', desc: 'Hydraulic systems, fire protection, agricultural infrastructure and large-scale industrial infrastructure works.' },
        { id: 'maintenance', title: 'Industrial Maintenance', desc: 'Preventive and corrective maintenance programs for plants, utilities and industrial facilities.' },
        { id: 'workforce', title: 'Alpha 7 Global Workforce', desc: 'B2B workforce partnerships, sourcing and industrial labor coordination for workforce-intensive industries.' },
      ],
    },
    projects: {
      index: '03 — Experience',
      title: 'Real operational experience across industrial sectors.',
      sub: 'A portfolio of more than 450 completed projects — anchored in heavy industry, infrastructure and workforce-intensive operations.',
      counter_label: '450+ project executions',
      categories: [
        'Industrial Warehouses',
        'Infrastructure Works',
        'Electrical Systems',
        'Fire Protection Systems',
        'Agricultural Infrastructure',
        'Greenhouses',
        'Hydraulic Systems',
        'Industrial Maintenance',
        'Concrete Structures',
        'Industrial Facilities',
        'Substations',
      ],
      clients_label: 'Trusted by industrial organizations',
    },
    industries: {
      index: '04 — Industries',
      title: 'Industries we operate in.',
      sub: 'From agriculture and warehousing to electrical infrastructure and industrial maintenance.',
      items: [
        { title: 'Agriculture', desc: 'Agricultural infrastructure, greenhouses, hydraulic and workforce support.' },
        { title: 'Construction', desc: 'Industrial construction, concrete and structural execution.' },
        { title: 'Industrial Operations', desc: 'Operational coordination for heavy industry environments.' },
        { title: 'Infrastructure', desc: 'Large-scale infrastructure and utility systems.' },
        { title: 'Electrical Engineering', desc: 'Distribution, substations and industrial electrical systems.' },
        { title: 'Industrial Maintenance', desc: 'Maintenance programs for plants and facilities.' },
        { title: 'Workforce-Intensive Industries', desc: 'Labor coordination for high-volume operational sectors.' },
      ],
    },
    workforce: {
      index: '05 — Alpha 7 Global Workforce',
      title: 'Operational Global Workforce Partnerships',
      sub: 'Supporting workforce-intensive industries through sourcing, coordination and pre-screened workforce partnerships.',
      description: 'Alpha 7 supports companies, contractors and operational industries through workforce sourcing, workforce coordination and industrial labor partnership solutions, anchored in real operational industry experience.',
      services: [
        { title: 'Workforce Sourcing', desc: 'Industrial workforce sourcing for operational environments.' },
        { title: 'Pre-Screening & Selection', desc: 'Pre-screened workforce aligned to operational requirements.' },
        { title: 'Construction Workforce Support', desc: 'Workforce partnerships for construction operations.' },
        { title: 'Agriculture Workforce Support', desc: 'Workforce coordination for agricultural operations.' },
        { title: 'Industrial Labor Coordination', desc: 'On-site labor coordination for industrial environments.' },
        { title: 'Workforce Pipeline Development', desc: 'Long-term workforce pipeline partnerships.' },
      ],
      why_title: 'Why Alpha 7 Global Workforce',
      why_body: 'Alpha 7 originates from construction, engineering and industrial operations — which is why we understand workforce-intensive industries, operational workforce needs, industrial environments, labor coordination and the reliability standards required for serious operational execution.',
      industries_supported: 'Industries Supported',
      industries_list: ['Agriculture', 'Construction', 'Industrial Operations', 'Infrastructure', 'Industrial Maintenance'],
      disclaimer: 'Alpha 7 Global Workforce delivers corporate B2B workforce partnerships. We do not offer visas, immigration services, guaranteed employment or legal advice.',
    },
    gallery: {
      index: '06 — Project Gallery',
      title: 'Inside our operations — a visual archive.',
      sub: 'A curated visual archive of real ALPHA 7 industrial and infrastructure projects. Filter by division to explore the work.',
      counter: 'projects shown',
      categories: {
        all: 'All',
        construction: 'Construction',
        electrical: 'Electrical Engineering',
        industrial: 'Industrial Operations',
        agriculture: 'Agriculture',
        workforce: 'Workforce',
      },
      view: 'View',
      close: 'Close',
      prev: 'Previous',
      next: 'Next',
      empty: 'No projects in this category yet.',
    },
    why: {
      index: '07 — Why Alpha 7',
      title: 'Operational depth, not marketing depth.',
      stats: [
        { num: '450+', label: 'Completed operational & infrastructure projects' },
        { num: '15+', label: 'Years of operational experience' },
        { num: '6', label: 'Specialized divisions' },
        { num: '7', label: 'Industries supported' },
      ],
      points: [
        'Real operational experience across construction, engineering and industrial environments.',
        'Engineering capability and execution standards aligned to industrial clients.',
        'Workforce understanding rooted in real industrial operations — not generic staffing.',
        'Long-term, transparent partnerships with contractors, operators and industrial groups.',
      ],
    },
    partner: {
      index: '08 — Partner With Us',
      title: 'Build reliable industrial and workforce partnerships.',
      sub: 'For contractors, industrial operators, agricultural businesses, infrastructure companies and workforce-intensive organizations.',
      cta: 'Start a Partnership',
    },
    community: {
      index: '08 — Community Commitment',
      eyebrow: 'CORPORATE RESPONSIBILITY',
      title: 'Long-term impact, beyond industrial operations.',
      lead: 'ALPHA 7 believes long-term impact also includes supporting communities and families beyond industrial operations.',
      body_1: 'We were honored to contribute to Fundación Piltsintli Texotli, an organization focused on supporting children and families through inclusion, care and community-centered initiatives.',
      body_2: 'Although the foundation is currently inactive due to operational and financial limitations, ALPHA 7 is currently working toward future support initiatives, fundraising efforts and the development of new facilities and infrastructure to help support future reactivation projects.',
      foundation_label: 'Foundation',
      foundation_name: 'Fundación Piltsintli Texotli',
      foundation_tag: 'Amado hijo azul.',
      status_label: 'Status',
      status_value: 'Currently inactive · Working toward reactivation',
      link_label: 'Visit on Instagram',
      pillars: [
        { k: 'Inclusion', v: 'Support for children and families through inclusion-centered programs.' },
        { k: 'Care', v: 'Community-centered care initiatives with long-term horizon.' },
        { k: 'Reactivation', v: 'Future infrastructure and facilities to support reactivation.' },
      ],
    },
    contact: {
      index: '10 — Contact',
      title: 'Speak directly with our corporate team.',
      sub: 'All inquiries are reviewed by the corporate office. Average response within two business days.',
      director_label: 'Director General',
      director_name: 'Iván Alejandro López Osorno',
      director_email: 'direccion@alpha7.com.mx',
      office_label: 'Corporate Office',
      office_value: 'Mexico — North America operations',
      fields: {
        full_name: 'Full Name',
        company: 'Company',
        email: 'Corporate Email',
        phone: 'Phone / WhatsApp',
        country: 'Country',
        inquiry_type: 'Type of Inquiry',
        industry: 'Industry',
        message: 'Message',
      },
      inquiry_options: {
        construction_project: 'Construction Project',
        electrical_engineering: 'Electrical Engineering',
        industrial_maintenance: 'Industrial Maintenance',
        workforce_partnership: 'Workforce Partnership',
        agriculture_workforce: 'Agriculture Workforce',
        construction_workforce: 'Construction Workforce',
        general_business_inquiry: 'General Business Inquiry',
      },
      submit: 'Send Inquiry',
      sending: 'Sending…',
      success_title: 'Inquiry received.',
      success_body: 'Our corporate team will respond within two business days.',
      error: 'Something went wrong. Please try again or write directly to direccion@alpha7.com.mx.',
      privacy_notice: 'By submitting, you accept our',
      privacy_link: 'Privacy & Data Notice',
    },
    chat: {
      title: 'A7 Assistant',
      subtitle: 'Corporate AI · Bilingual',
      placeholder: 'Ask about our services…',
      send: 'Send',
      open: 'Chat with us',
      welcome: 'Hello — I am the Alpha 7 corporate assistant. How can I help with your engineering, industrial or workforce partnership inquiry?',
      quick: ['Discuss a Partnership', 'Workforce Inquiry', 'Construction Inquiry', 'Contact Alpha 7'],
      disclaimer: 'A7 Assistant does not provide visas, immigration, employment guarantees or legal advice.',
    },
    footer: {
      tagline: 'Engineering, Infrastructure & Global Workforce Partnerships.',
      nav_label: 'Navigation',
      contact_label: 'Corporate',
      legal_label: 'Legal',
      privacy: 'Privacy & Data Notice',
      rights: 'All rights reserved.',
    },
    privacy: {
      title: 'Privacy & Data Notice',
      updated: 'Last updated: 2026',
      back: 'Back to home',
      sections: [
        {
          h: 'Scope',
          p: 'This notice describes how ALPHA 7 Soluciones y Proyectos processes the information you submit through our corporate contact form and AI assistant on alpha7.com.mx.',
        },
        {
          h: 'Data we collect',
          p: 'Through the contact form we receive: full name, company, corporate email, phone, country, industry, type of inquiry and the message you share with us. Conversations with the AI assistant may be stored for service quality.',
        },
        {
          h: 'How we use it',
          p: 'Submissions are used exclusively to respond to your business inquiry and to evaluate potential corporate, industrial or workforce partnerships. Data is reviewed by the corporate office and is never sold, rented or shared with third parties for marketing purposes.',
        },
        {
          h: 'Storage and security',
          p: 'Submissions are stored on protected corporate infrastructure and accessed only by authorized personnel. We apply commercially reasonable security measures and retention periods consistent with our business needs.',
        },
        {
          h: 'Your rights',
          p: 'You may request access, correction or deletion of your submission at any time by writing to direccion@alpha7.com.mx with the email address used in the original inquiry.',
        },
        {
          h: 'AI Assistant',
          p: 'Our AI assistant is informational only. It does not offer visas, immigration outcomes, guaranteed employment, medical, legal or financial advice. All commercial agreements are handled directly by the corporate office.',
        },
      ],
    },
  },

  es: {
    nav: {
      about: 'Identidad',
      divisions: 'Divisiones',
      experience: 'Experiencia',
      industries: 'Industrias',
      workforce: 'Workforce',
      gallery: 'Galería',
      contact: 'Contacto',
      cta: 'Aliarse con Alpha 7',
    },
    hero: {
      eyebrow: 'EST. — OPERACIONES INDUSTRIALES / MÉXICO',
      title_pre: 'Ingeniería, infraestructura',
      title_accent: 'y alianzas de fuerza laboral',
      title_post: 'a nivel global.',
      sub: 'Entregamos excelencia industrial, desarrollo de infraestructura y alianzas de fuerza laboral en México y Norteamérica. Experiencia operativa en más de 450 ejecuciones de proyectos.',
      btn_primary: 'Explorar Servicios',
      btn_secondary: 'Aliarse con Alpha 7',
      scroll: 'BAJAR',
      ticker: 'MÁS DE 450 PROYECTOS OPERATIVOS E INFRAESTRUCTURA COMPLETADOS',
    },
    marquee: [
      'Construcción Industrial',
      'Ingeniería Eléctrica',
      'Subestaciones',
      'Protección contra Incendios',
      'Infraestructura Agrícola',
      'Sistemas Hidráulicos',
      'Alianzas de Workforce',
      'Mantenimiento Industrial',
    ],
    about: {
      index: '01 — Identidad',
      title_pre: 'Un grupo industrial',
      title_accent: 'multidisciplinario',
      title_post: 'construido sobre experiencia operativa.',
      body_1: 'ALPHA 7 Soluciones y Proyectos es un grupo multidisciplinario de ingeniería, operaciones industriales y alianzas de fuerza laboral con base en México, con experiencia operativa en ingeniería civil, electromecánica e industrial, desarrollo de infraestructura y sectores intensivos en mano de obra.',
      body_2: 'Nuestro trabajo abarca construcción industrial, sistemas eléctricos, subestaciones, infraestructura hidráulica, sistemas de protección contra incendios, infraestructura agrícola, invernaderos y mantenimiento industrial a gran escala — sostenidos por una cultura corporativa de confiabilidad, transparencia y excelencia operativa. Más de 450 proyectos ejecutados en sectores industriales.',
      pillars: ['Confiabilidad', 'Excelencia Operativa', 'Transparencia', 'Alianzas de largo plazo'],
    },
    divisions: {
      index: '02 — Divisiones',
      title: 'Seis divisiones. Un solo estándar operativo.',
      sub: 'Una estructura verticalmente integrada para servir a clientes industriales y contratistas en México y Norteamérica.',
      items: [
        { id: 'construction', title: 'Construcción', desc: 'Construcción industrial, estructuras de concreto y ejecución de instalaciones para naves, plantas e infraestructura.' },
        { id: 'electrical', title: 'Ingeniería Eléctrica', desc: 'Sistemas eléctricos industriales, distribución, soporte de subestaciones y ejecución electromecánica.' },
        { id: 'operations', title: 'Operaciones Industriales', desc: 'Coordinación operativa en sitio para entornos industriales, contratistas y programas de infraestructura.' },
        { id: 'infrastructure', title: 'Soluciones de Infraestructura', desc: 'Sistemas hidráulicos, protección contra incendios, infraestructura agrícola y obras de infraestructura industrial a gran escala.' },
        { id: 'maintenance', title: 'Mantenimiento Industrial', desc: 'Programas de mantenimiento preventivo y correctivo para plantas, servicios e instalaciones industriales.' },
        { id: 'workforce', title: 'Alpha 7 Global Workforce', desc: 'Alianzas B2B de fuerza laboral, sourcing y coordinación de mano de obra industrial.' },
      ],
    },
    projects: {
      index: '03 — Experiencia',
      title: 'Experiencia operativa real en sectores industriales.',
      sub: 'Un portafolio de más de 450 proyectos completados — anclado en industria pesada, infraestructura y operaciones intensivas en mano de obra.',
      counter_label: '450+ ejecuciones de proyectos',
      categories: [
        'Naves Industriales',
        'Obras de Infraestructura',
        'Sistemas Eléctricos',
        'Protección contra Incendios',
        'Infraestructura Agrícola',
        'Invernaderos',
        'Sistemas Hidráulicos',
        'Mantenimiento Industrial',
        'Estructuras de Concreto',
        'Instalaciones Industriales',
        'Subestaciones',
      ],
      clients_label: 'Organizaciones industriales que han confiado en nosotros',
    },
    industries: {
      index: '04 — Industrias',
      title: 'Industrias en las que operamos.',
      sub: 'Desde agricultura y almacenamiento hasta infraestructura eléctrica y mantenimiento industrial.',
      items: [
        { title: 'Agricultura', desc: 'Infraestructura agrícola, invernaderos, hidráulica y soporte de fuerza laboral.' },
        { title: 'Construcción', desc: 'Construcción industrial, concreto y ejecución estructural.' },
        { title: 'Operaciones Industriales', desc: 'Coordinación operativa para entornos de industria pesada.' },
        { title: 'Infraestructura', desc: 'Infraestructura y sistemas de utilidades a gran escala.' },
        { title: 'Ingeniería Eléctrica', desc: 'Distribución, subestaciones y sistemas eléctricos industriales.' },
        { title: 'Mantenimiento Industrial', desc: 'Programas de mantenimiento para plantas e instalaciones.' },
        { title: 'Industrias intensivas en mano de obra', desc: 'Coordinación de fuerza laboral para sectores operativos de alto volumen.' },
      ],
    },
    workforce: {
      index: '05 — Alpha 7 Global Workforce',
      title: 'Alianzas Operativas Globales de Fuerza Laboral',
      sub: 'Apoyamos industrias intensivas en mano de obra mediante sourcing, coordinación y alianzas de fuerza laboral pre-evaluada.',
      description: 'Alpha 7 apoya a empresas, contratistas e industrias operativas mediante sourcing, coordinación y soluciones de alianza de mano de obra industrial, basadas en experiencia operativa real.',
      services: [
        { title: 'Sourcing de Fuerza Laboral', desc: 'Sourcing de fuerza laboral industrial para entornos operativos.' },
        { title: 'Pre-evaluación y Selección', desc: 'Fuerza laboral pre-evaluada alineada a requerimientos operativos.' },
        { title: 'Soporte de Construcción', desc: 'Alianzas de fuerza laboral para operaciones de construcción.' },
        { title: 'Soporte Agrícola', desc: 'Coordinación de fuerza laboral para operaciones agrícolas.' },
        { title: 'Coordinación Laboral Industrial', desc: 'Coordinación laboral en sitio para entornos industriales.' },
        { title: 'Pipeline de Fuerza Laboral', desc: 'Alianzas de pipeline laboral de largo plazo.' },
      ],
      why_title: 'Por qué Alpha 7 Global Workforce',
      why_body: 'Alpha 7 nace de la construcción, la ingeniería y las operaciones industriales — por eso entendemos las industrias intensivas en mano de obra, las necesidades operativas de fuerza laboral, los entornos industriales, la coordinación laboral y los estándares de confiabilidad que exige una operación seria.',
      industries_supported: 'Industrias Atendidas',
      industries_list: ['Agricultura', 'Construcción', 'Operaciones Industriales', 'Infraestructura', 'Mantenimiento Industrial'],
      disclaimer: 'Alpha 7 Global Workforce ofrece alianzas corporativas B2B de fuerza laboral. No ofrecemos visas, servicios migratorios, empleo garantizado ni asesoría legal.',
    },
    gallery: {
      index: '06 — Galería de Proyectos',
      title: 'Por dentro de nuestras operaciones — un archivo visual.',
      sub: 'Un archivo visual curado de proyectos industriales y de infraestructura reales de ALPHA 7. Filtre por división para explorar el trabajo.',
      counter: 'proyectos mostrados',
      categories: {
        all: 'Todos',
        construction: 'Construcción',
        electrical: 'Ingeniería Eléctrica',
        industrial: 'Operaciones Industriales',
        agriculture: 'Agricultura',
        workforce: 'Fuerza Laboral',
      },
      view: 'Ver',
      close: 'Cerrar',
      prev: 'Anterior',
      next: 'Siguiente',
      empty: 'Aún no hay proyectos en esta categoría.',
    },
    why: {
      index: '07 — Por qué Alpha 7',
      title: 'Profundidad operativa, no profundidad de marketing.',
      stats: [
        { num: '15+', label: 'Años de experiencia operativa' },
        { num: '6', label: 'Divisiones especializadas' },
        { num: '7', label: 'Industrias atendidas' },
        { num: '100%', label: 'Enfoque corporativo B2B' },
      ],
      points: [
        'Experiencia operativa real en construcción, ingeniería y entornos industriales.',
        'Capacidad de ingeniería y estándares de ejecución alineados a clientes industriales.',
        'Entendimiento de fuerza laboral arraigado en operaciones industriales reales — no staffing genérico.',
        'Alianzas de largo plazo, transparentes, con contratistas, operadores y grupos industriales.',
      ],
    },
    partner: {
      index: '09 — Aliarse con Nosotros',
      title: 'Construya alianzas industriales y de fuerza laboral confiables.',
      sub: 'Para contratistas, operadores industriales, empresas agrícolas, compañías de infraestructura y organizaciones intensivas en mano de obra.',
      cta: 'Iniciar Alianza',
    },
    community: {
      index: '08 — Compromiso con la Comunidad',
      eyebrow: 'RESPONSABILIDAD CORPORATIVA',
      title: 'Impacto de largo plazo, más allá de las operaciones industriales.',
      lead: 'ALPHA 7 cree que el impacto de largo plazo también incluye apoyar a comunidades y familias más allá de las operaciones industriales.',
      body_1: 'Tuvimos el honor de contribuir con Fundación Piltsintli Texotli, una organización enfocada en apoyar a niños y familias mediante inclusión, cuidado e iniciativas centradas en la comunidad.',
      body_2: 'Aunque la fundación se encuentra actualmente inactiva por limitaciones operativas y financieras, ALPHA 7 está trabajando en iniciativas futuras de apoyo, esfuerzos de recaudación y el desarrollo de nuevas instalaciones e infraestructura para apoyar futuros proyectos de reactivación.',
      foundation_label: 'Fundación',
      foundation_name: 'Fundación Piltsintli Texotli',
      foundation_tag: 'Amado hijo azul.',
      status_label: 'Estado',
      status_value: 'Actualmente inactiva · Trabajando hacia la reactivación',
      link_label: 'Visitar Instagram',
      pillars: [
        { k: 'Inclusión', v: 'Apoyo a niños y familias mediante programas centrados en inclusión.' },
        { k: 'Cuidado', v: 'Iniciativas comunitarias de cuidado con horizonte de largo plazo.' },
        { k: 'Reactivación', v: 'Infraestructura e instalaciones para apoyar la reactivación futura.' },
      ],
    },
    contact: {
      index: '10 — Contacto',
      title: 'Hable directamente con nuestro equipo corporativo.',
      sub: 'Todas las solicitudes son revisadas por la oficina corporativa de ALPHA 7 Soluciones y Proyectos. Respuesta promedio en dos días hábiles.',
      director_label: 'Director General',
      director_name: 'Iván Alejandro López Osorno',
      director_email: 'direccion@alpha7.com.mx',
      office_label: 'Oficina Corporativa',
      office_value: 'México — Operaciones en Norteamérica',
      fields: {
        full_name: 'Nombre Completo',
        company: 'Empresa',
        email: 'Correo Corporativo',
        phone: 'Teléfono / WhatsApp',
        country: 'País',
        inquiry_type: 'Tipo de Solicitud',
        industry: 'Industria',
        message: 'Mensaje',
      },
      inquiry_options: {
        construction_project: 'Proyecto de Construcción',
        electrical_engineering: 'Ingeniería Eléctrica',
        industrial_maintenance: 'Mantenimiento Industrial',
        workforce_partnership: 'Alianza de Fuerza Laboral',
        agriculture_workforce: 'Fuerza Laboral Agrícola',
        construction_workforce: 'Fuerza Laboral de Construcción',
        general_business_inquiry: 'Consulta de Negocio General',
      },
      submit: 'Enviar Solicitud',
      sending: 'Enviando…',
      success_title: 'Solicitud recibida.',
      success_body: 'Nuestro equipo corporativo responderá en dos días hábiles.',
      error: 'Ocurrió un error. Intente de nuevo o escriba directamente a direccion@alpha7.com.mx.',
      privacy_notice: 'Al enviar, acepta nuestro',
      privacy_link: 'Aviso de Privacidad',
    },
    chat: {
      title: 'A7 Assistant',
      subtitle: 'IA Corporativa · Bilingüe',
      placeholder: 'Pregunte sobre nuestros servicios…',
      send: 'Enviar',
      open: 'Hable con nosotros',
      welcome: 'Hola — soy el asistente corporativo de Alpha 7. ¿Cómo puedo ayudar con su consulta de ingeniería, industrial o de alianza de fuerza laboral?',
      quick: ['Conversar una Alianza', 'Consulta de Workforce', 'Consulta de Construcción', 'Contactar Alpha 7'],
      disclaimer: 'A7 Assistant no ofrece visas, migración, garantías de empleo ni asesoría legal.',
    },
    footer: {
      tagline: 'Ingeniería, Infraestructura y Alianzas Globales de Fuerza Laboral.',
      nav_label: 'Navegación',
      contact_label: 'Corporativo',
      legal_label: 'Legal',
      privacy: 'Aviso de Privacidad',
      rights: 'Todos los derechos reservados.',
    },
    privacy: {
      title: 'Aviso de Privacidad',
      updated: 'Última actualización: 2026',
      back: 'Volver al inicio',
      sections: [
        {
          h: 'Alcance',
          p: 'Este aviso describe cómo ALPHA 7 Soluciones y Proyectos procesa la información que usted envía a través de nuestro formulario corporativo y del asistente de IA en alpha7.com.mx.',
        },
        {
          h: 'Datos que recolectamos',
          p: 'A través del formulario recibimos: nombre completo, empresa, correo corporativo, teléfono, país, industria, tipo de consulta y el mensaje que comparte con nosotros. Las conversaciones con el asistente pueden almacenarse para fines de calidad de servicio.',
        },
        {
          h: 'Uso de la información',
          p: 'Las solicitudes se utilizan exclusivamente para responder a su consulta de negocio y evaluar posibles alianzas corporativas, industriales o de fuerza laboral. Los datos son revisados por la oficina corporativa y nunca son vendidos, rentados ni compartidos con terceros para fines de mercadotecnia.',
        },
        {
          h: 'Almacenamiento y seguridad',
          p: 'Las solicitudes se almacenan en infraestructura corporativa protegida y solo es accedida por personal autorizado. Aplicamos medidas de seguridad comercialmente razonables y plazos de retención acordes a nuestras necesidades operativas.',
        },
        {
          h: 'Sus derechos',
          p: 'Puede solicitar acceso, corrección o eliminación de su envío en cualquier momento escribiendo a direccion@alpha7.com.mx desde el correo utilizado en la solicitud original.',
        },
        {
          h: 'Asistente de IA',
          p: 'Nuestro asistente de IA es solo informativo. No ofrece visas, resultados migratorios, empleo garantizado, ni asesoría médica, legal o financiera. Todo acuerdo comercial se maneja directamente por la oficina corporativa.',
        },
      ],
    },
  },
};
